import { Dispatch } from 'redux';
import { routeToSpecificScope } from '../../helpers/helpersts';
import {
  ChangeTablePropertiesOrderColumn,
  ChangeTablePropertiesPinnedRows, ChangeTablePropertiesScroll, ChangeTablePropertiesSelectedRows, PinnedRows,
  SAVE_TABLE_PROPERTIES_ON_LOCAL_STORAGE, SelectedRows,
  TablePropertiesAction,
  TablePropertiesScroll
} from '../types';
import { RootState } from '../reducers';

export const replaceTablePropertiesAction = (scope: string, orderColumn?: number, pinnedRows?: PinnedRows, selectedRows?: SelectedRows, isPersistent?: boolean) => {
  return {
    type: TablePropertiesAction.REPLACE_TABLE_PROPERTIES,
    scope,
    orderColumn,
    pinnedRows,
    selectedRows,
    SAVE_LOCAL_STORAGE: isPersistent ? SAVE_TABLE_PROPERTIES_ON_LOCAL_STORAGE : undefined
  };
};

export const replaceTableProperties = (orderColumn?: number, pinnedRows?: PinnedRows, selectedRows?: SelectedRows, isPersistent?: boolean, forceScope?: string) => {
  return (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forceScope || routeToSpecificScope(path);
    dispatch(replaceTablePropertiesAction(scope, orderColumn, pinnedRows, selectedRows, isPersistent));
  };
};

export const changeTablePropertiesAction = ({ scope, orderColumn, pinnedRows, selectedRows, scroll, isPersistent }:
                                              { scope: string, orderColumn?: number, pinnedRows?: PinnedRows, selectedRows?: 
                                                SelectedRows, scroll?: TablePropertiesScroll, isPersistent?: boolean }) => {
  return {
    type: TablePropertiesAction.CHANGE_TABLE_PROPERTIES,
    scope,
    orderColumn,
    pinnedRows,
    selectedRows,
    scroll,
    SAVE_LOCAL_STORAGE: isPersistent ? SAVE_TABLE_PROPERTIES_ON_LOCAL_STORAGE : undefined
  };
};

export const changeTablePropertiesOrderColumn: ChangeTablePropertiesOrderColumn = (orderColumn, isPersistent, forceScope) => {
  return (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope: string = forceScope || routeToSpecificScope(path);
    dispatch(changeTablePropertiesAction({ scope, orderColumn, isPersistent }));
  };
};

export const changeTablePropertiesPinnedRows: ChangeTablePropertiesPinnedRows = (pinnedRows, isPersistent, forceScope) => {
  return (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forceScope || routeToSpecificScope(path);
    dispatch(changeTablePropertiesAction({ scope, pinnedRows, isPersistent }));
  };
};

export const changeTablePropertiesSelectedRows: ChangeTablePropertiesSelectedRows = (selectedRows, isPersistent, forceScope) => {
  return (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forceScope || routeToSpecificScope(path);
    dispatch(changeTablePropertiesAction({ scope, selectedRows, isPersistent }));
  };
};

export const changeTablePropertiesScroll: ChangeTablePropertiesScroll = (scroll, isPersistent, forceScope) => {
  return (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forceScope || routeToSpecificScope(path);
    dispatch(changeTablePropertiesAction({ scope, scroll, isPersistent }));
  };
};
